export const SET_DRAWER_STATUS = "SET_DRAWER_STATUS";
export const SET_STEP_INDEX = "SET_STEP_INDEX";
export const SET_TUTORIAL_OPEN = "SET_TUTORIAL_OPEN";
export const SET_INITIAL_RENDER = "SET_INITIAL_RENDER";
